import { useEffect, useState, useRef } from 'react';
import './MentionUserList.scss';
import PropTypes from 'prop-types';
import ImageComponent from '../ImageComponent';
import { isDisplayNamePhoneNumber } from '../../../../Helpers/Utility';

function MentionUserList(props = {}) {
    const { GroupParticiapantsList = [], handleMentionedData = () => {}, chatScreenName = '' } = props;
    const [sortedGroupList, setSortedGroupList] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const itemRefs = useRef([]);

    useEffect(() => {
        GroupParticiapantsList.sort(
            (b, c) =>
                isNaN(parseInt(c.rosterData.displayName)) - isNaN(parseInt(b.rosterData.displayName)) ||
                String(b.rosterData.displayName).localeCompare(String(c.rosterData.displayName)),
        );
        setSortedGroupList(GroupParticiapantsList);
        setActiveIndex(0); // reset to first item when list changes
    }, [GroupParticiapantsList]);

    useEffect(() => {
        const handleKeyDown = e => {
            if (sortedGroupList.length === 0) return;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                setActiveIndex(prevIndex => (prevIndex < sortedGroupList.length - 1 ? prevIndex + 1 : prevIndex));
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                setActiveIndex(prevIndex => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
            } else if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                const activeUser = sortedGroupList[activeIndex];
                if (activeUser && activeUser.isAdminBlocked === false) {
                    handleMentionedData(activeUser.userId, chatScreenName, true);
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown, true);
        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [sortedGroupList, activeIndex, handleMentionedData, chatScreenName]);

    useEffect(() => {
        // Scroll active item into view
        if (itemRefs.current[activeIndex]) {
            itemRefs.current[activeIndex].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    }, [activeIndex]);

    return (
        <div className="mention_wraper scrollbar-thin">
            <ul>
                {sortedGroupList.map((obj, index) => {
                    let rosterData = obj.rosterData;
                    let isNamePhoneNumber = isDisplayNamePhoneNumber(rosterData.displayName, rosterData.mobileNumber);
                    let displayName =
                        rosterData.displayName !== ''
                            ? isNamePhoneNumber
                                ? `~${rosterData.name}`
                                : rosterData.displayName
                            : rosterData.userId;
                    const isActive = index === activeIndex;
                    return (
                        <li
                            key={obj.userId}
                            ref={el => (itemRefs.current[index] = el)}
                            className={isActive ? 'active' : ''}
                        >
                            <button
                                onClick={() =>
                                    obj.isAdminBlocked === false &&
                                    handleMentionedData(obj.userId, chatScreenName, true)
                                }
                                onMouseEnter={() => setActiveIndex(index)}
                                className={`user_card_action ${isActive ? 'active' : ''}`}
                                type="button"
                            >
                                <div className="user_card">
                                    <div className="user_image">
                                        <ImageComponent
                                            chatType={'chat'}
                                            imageToken={
                                                rosterData.thumbImage && rosterData.thumbImage !== ''
                                                    ? rosterData.thumbImage
                                                    : rosterData.image
                                            }
                                            name={displayName}
                                        />
                                    </div>
                                    <div className="user_name">{displayName}</div>
                                    {/* <div className='user_phone_number'>{formatMobileNumber(rosterData.mobileNumber)}</div> */}
                                </div>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default MentionUserList;

MentionUserList.propTypes = {
    GroupParticiapantsList: PropTypes.array,
    handleMentionedData: PropTypes.func,
    chatScreenName: PropTypes.string,
};
